export default __webpack_public_path__ + "static/media/demo-doodle-5.8ec668ac.png";